module.exports = __webpack_public_path__ + "media/images/p-6c22ec94b554758fac0713233fbff476.gif";